import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { crmApi } from "../api/client";

function useAuthToken() {
  const [token, setToken] = useState(() => {
    try { return localStorage.getItem("token") || null; } catch { return null; }
  });
  useEffect(() => {
    const sync = () => {
      try { setToken(localStorage.getItem("token") || null); } catch { setToken(null); }
    };
    window.addEventListener("storage", sync);
    window.addEventListener("auth-token-changed", sync);
    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener("auth-token-changed", sync);
    };
  }, []);
  return token;
}

export function useOrgMode() {
  const token = useAuthToken();
  return useQuery({
    queryKey: ["crm", "org-mode"],
    enabled: !!token,
    queryFn: async () => {
      const { data } = await crmApi.get("/org-mode");
      return {
        usesCompanies: !!data?.usesCompanies,
        hasCompanies: !!data?.hasCompanies,
      };
    },
    staleTime: 60_000,
  });
}
